module.exports = __webpack_public_path__ + "static/img/img_culture_g.2e20d98f.png";